import React, {Component} from 'react'
import FormatMessage from "../messages/FormatMessage";
import {withRouter} from 'react-router-dom';

class EQHeader extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<div className="SiteHeader">
            <div className="FixedLayout SiteHeader-layout">
                <div className="FixedLayoutAside SiteHeader-aside">
                    <div className="SiteHeader-logoContainer">
                        <div className="SiteHeader-logoLarge">
                            <a href="https://www.dualcitizenship.com/" className="SiteLogo">
                                <FormatMessage id="application.site.pageHeader"/>
                            </a>
                        </div>
                        <div className="SiteHeader-logoInBetween">
                            <a href="https://www.dualcitizenship.com/" className="SiteLogo SiteLogo-medium">
                                <FormatMessage id="application.site.pageHeader"/>
                            </a>
                        </div>
                        <div className="SiteHeader-logoSmall">
                            <a href="https://www.dualcitizenship.com/" className="SiteLogo SiteLogo-small">
                                <FormatMessage id="application.site.pageHeader"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}

export default withRouter(EQHeader)
